define('Components/ReorderWidget/js/views/ReorderWidgetInstanceView',[
    'jquery',
    'WidgetInstanceView',
    'app',
    'template!Components/ReorderWidget/templates/reorder',
    'template!Components/ReorderWidget/templates/reorder-burger',
    'views/blocks/ReorderOrderSingleView',
    'InternalLinkView',
    'router'
],
    function($, WidgetInstanceView, app, template, templateBurger, ReorderOrderSingleView, InternalLinkView, router){
        return WidgetInstanceView.extend({
            name: 'ReorderWidgetInstanceView',
            events: {
                'click .btn-reorder': 'reorder',
                'click .widget-reorder-burger__preview .title': 'toggleLastOrders',
                'click .widget-reorder-burger__preview .open': 'toggleLastOrders',
                'click .widget-reorder-burger__content .close': 'toggleLastOrders',
            },

            afterRender:function(){
                var view = this,
                    customer = app.getCustomer();

                view.listenTo(customer,'login logout',this.rerender);
                view.$('.reorder-wrapper__orders').html('')

                customer.getLastReorderOrders().each(function(order, index) {
                    var reorderView = view.attachView(new ReorderOrderSingleView({order:order}));
                    view.$('.reorder-wrapper__orders').append(reorderView.el);
                    if (index === 0 && view.$('.widget-reorder-burger__preview-block')) {
                        var reorderPreview = view.attachView(new ReorderOrderSingleView({order:order}));
                        view.$('.widget-reorder-burger__preview-block').html(reorderPreview.el);
                    }
                })
            },

            getTemplate:function () {
                if (this.model.getTemplate() === 'reorder-burger') {
                    return templateBurger
                } else {
                    return template
                }
            },

            toggleLastOrders:function(e) {
                e.preventDefault();
                var view = this,
                    content = view.$('.widget-reorder-burger__content');

                content.toggleClass('active')
            }
        })
});
